import { AxnAdminSecurityRule } from "@idw-types/data/management-console/axnadmin";
import { RefreshResult } from "@idw-types/common";

export enum SecurityRulesActionTypes {
    SET_SECURITY_RULES_LOADING = "SET_SECURITY_RULES_LOADING",
    SET_SECURITY_RULES = "SET_SECURITY_RULES",
    ADD_SECURITY_RULE = "ADD_SECURITY_RULE",
    REPLACE_SECURITY_RULE = "REPLACE_SECURITY_RULE",
    // refresh
    SET_SECURITY_RULES_REFRESHING = "SET_SECURITY_RULES_REFRESHING",
    SET_SECURITY_RULES_REFRESH_RESULTS = "SET_SECURITY_RULES_REFRESH_RESULTS"
}

type SetSecurityRulesLoadingAction = {
    type: SecurityRulesActionTypes.SET_SECURITY_RULES_LOADING;
    payload: { isLoading: boolean; }
};

export const setSecurityRulesLoading = (isLoading: boolean): SetSecurityRulesLoadingAction => ({
    type: SecurityRulesActionTypes.SET_SECURITY_RULES_LOADING,
    payload: { isLoading }
});

type SetSecurityRulesAction = {
    type: SecurityRulesActionTypes.SET_SECURITY_RULES;
    payload: { securityRules: Array<AxnAdminSecurityRule>; }
}

export const setSecurityRules = (securityRules: Array<AxnAdminSecurityRule>): SetSecurityRulesAction => ({
    type: SecurityRulesActionTypes.SET_SECURITY_RULES,
    payload: { securityRules }
});

type AddSecurityRuleAction = {
    type: SecurityRulesActionTypes.ADD_SECURITY_RULE;
    payload: { securityRule: AxnAdminSecurityRule }
};

export const addSecurityRule = (securityRule: AxnAdminSecurityRule): AddSecurityRuleAction => ({
    type: SecurityRulesActionTypes.ADD_SECURITY_RULE,
    payload: { securityRule }
});

type ReplaceSecurityRuleAction = {
    type: SecurityRulesActionTypes.REPLACE_SECURITY_RULE;
    payload: { securityRule: AxnAdminSecurityRule };
};

export const replaceSecurityRule = (securityRule: AxnAdminSecurityRule): ReplaceSecurityRuleAction => ({
    type: SecurityRulesActionTypes.REPLACE_SECURITY_RULE,
    payload: { securityRule }
});

// refresh
type SetSecurityRulesRefreshingAction = {
    type: SecurityRulesActionTypes.SET_SECURITY_RULES_REFRESHING,
    payload: { isRefreshing: boolean; }
};

export const setSecurityRulesRefreshing = (isRefreshing: boolean): SetSecurityRulesRefreshingAction => ({
    type: SecurityRulesActionTypes.SET_SECURITY_RULES_REFRESHING,
    payload: { isRefreshing }
});

type SetSecurityRulesRefreshResultAction = {
    type: SecurityRulesActionTypes.SET_SECURITY_RULES_REFRESH_RESULTS,
    payload: { refreshResults: Array<RefreshResult>; lastRefreshDate: Date; }
}

export const setSecurityRulesRefreshResults = (refreshResults: Array<RefreshResult>, lastRefreshDate: Date): SetSecurityRulesRefreshResultAction => ({
    type: SecurityRulesActionTypes.SET_SECURITY_RULES_REFRESH_RESULTS,
    payload: { refreshResults, lastRefreshDate }
});


export type SecurityRulesActions =
    SetSecurityRulesLoadingAction |
    SetSecurityRulesAction |
    AddSecurityRuleAction |
    ReplaceSecurityRuleAction |
    SetSecurityRulesRefreshingAction |
    SetSecurityRulesRefreshResultAction